module.exports = __webpack_public_path__ + "static/media/vertical.da8d0375.png";